/* src/app/shared/components/shipping-guide-dialog/shipping-guide-dialog.component.scss */
.shipping-guide-dialog .pagetitle {
  font-weight: 600;
}
/*# sourceMappingURL=shipping-guide-dialog.component.css.map */
